import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/0uWbHWR7uVlwNf29dTNk/locations/8cFbUqF6Q7DFaX69phJL`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="85%"
                  maxWidth="250px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/0uWbHWR7uVlwNf29dTNk/locations/8cFbUqF6Q7DFaX69phJL`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="240px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
